module.exports = __webpack_public_path__ + "static/media/beef.eefdd24d.jpg";